import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = {
  key: 0,
  class: "new-table table-auto min-w-full border border-gray-300"
}
const _hoisted_3 = { class: "bg-gray-100" }
const _hoisted_4 = { class: "flex items-center gap-1" }
const _hoisted_5 = { class: "flex items-center gap-1" }
const _hoisted_6 = { class: "flex items-center gap-1" }
const _hoisted_7 = { class: "flex items-center gap-1" }
const _hoisted_8 = { class: "flex items-center gap-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_10 = { class: "py-4 px-8 text-sm font-medium text-primary truncate text-ellipsis max-w-[300px]" }
const _hoisted_11 = {
  key: 0,
  class: "py-4 px-8 text-sm text-tertiary truncate text-ellipsis max-w-[300px]"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "py-4 px-8 text-sm text-tertiary truncate text-ellipsis max-w-[300px]" }
const _hoisted_15 = { class: "py-4 px-8 text-sm text-tertiary truncate text-ellipsis max-w-[300px]" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "py-4 px-8 text-sm text-tertiary truncate text-ellipsis max-w-[300px]" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "py-4 px-8 text-sm font-semibold" }
const _hoisted_22 = { class: "flex gap-4 justify-start items-center flex-wrap min-w-[100px]" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 1,
  class: "flex justify-center items-center flex-col border border-[#EAECF0] rounded w-full p-[60px] mt-4"
}
const _hoisted_27 = { class: "max-w-[350px] flex justify-center items-center flex-col text-center" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "py-2 text-primary font-semibold" }, "No Classes found", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-tertiary" }, "Use the \"Add Class\" button above to start setting these up.", -1)
const _hoisted_30 = {
  key: 2,
  class: "mt-6 text-left flex justify-start items-center gap-4"
}
const _hoisted_31 = { class: "text-sm text-gray-600" }
const _hoisted_32 = { class: "p-6 text-center" }
const _hoisted_33 = { class: "flex justify-center items-center mb-4" }
const _hoisted_34 = { class: "text-lg font-semibold text-primary mb-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "text-tertiary mb-6 text-sm" }, " Are you sure you want to delete this Class? This action cannot be undone. ", -1)
const _hoisted_36 = { class: "flex justify-center items-center flex-col gap-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "Delete", -1)
const _hoisted_38 = {
  key: 0,
  class: "relative inline-block ml-2"
}
const _hoisted_39 = { class: "p-6 text-center" }
const _hoisted_40 = { class: "flex justify-center items-center mb-4" }
const _hoisted_41 = { class: "text-lg font-semibold text-primary mb-4" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "text-tertiary mb-6 text-sm" }, " In order to delete this Class, those Students must first be archived - or moved into differente Classes. ", -1)
const _hoisted_43 = { class: "flex justify-center items-center flex-col gap-2" }
const _hoisted_44 = { class: "p-8 relative" }
const _hoisted_45 = { class: "flex items-center justify-start mb-6" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold" }, "Edit Class"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-tertiary" }, "Update Class details.")
], -1)
const _hoisted_47 = {
  key: 0,
  class: "mb-4 p-4 bg-red-50 text-red-500 text-sm rounded-md flex items-center justify-start gap-2"
}
const _hoisted_48 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "Class Name", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1)
const _hoisted_51 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "Subject", -1)
const _hoisted_53 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "Grade/Year", -1)
const _hoisted_55 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "Language", -1)
const _hoisted_57 = { class: "text-center relative h-5 w-5 d-block ml-2" }
const _hoisted_58 = { class: "absolute z-50 left-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_59 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "Learning Mode", -1)
const _hoisted_61 = { class: "text-center relative h-5 w-5 d-block ml-2" }
const _hoisted_62 = { class: "absolute z-50 left-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_63 = { class: "w-full" }
const _hoisted_64 = { class: "flex w-full justify-center mt-8 border-t border-[#EAECF0] pt-8 flex-col gap-2" }
const _hoisted_65 = {
  type: "submit",
  class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap disabled:opacity-50 w-full"
}
const _hoisted_66 = {
  key: 0,
  class: "inline-block me-2",
  role: "status"
}

import { ref, computed, onBeforeMount, watch, onMounted} from 'vue'
import { useSchoolStore } from "@/stores/schoolStore";
import { useSubjectStore } from '@/stores/subjectStore';
import { useUserStore } from "@/stores/userStore";
import { useAdminStore } from '@/stores/adminStore';
import { useFilterStore } from "@/stores/filterStore";
import { useSchoolGroupStore } from "@/stores/schoolGroupsStore";
import { useDataStore } from "@/stores/dataStore";
import { useLearnerStore } from "@/stores/learnerStore";
import { unionBy } from "lodash";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/vue/20/solid";
import { showToast } from '@/utils/toastUtils';
import { useI18n } from 'vue-i18n'
import router from "@/router";
import { useWondeApiStore } from '@/stores/wondeStore';

interface Class {
  _id: string;
  name: string;
  subject: string;
  gradeLevel?: number;
  admins: any[];
  [key: string]: any;
  learningMode: any[];
}

interface ClassToDelete {
  teacher: string;
  classGroup: string;
}

interface Teacher {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  designation: string;
  phoneNumber: string; // Add the phoneNumber property
  assignedClasses: { class: string; subject: string; learnerCount: number }[];
  status: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassesTableComponent',
  setup(__props) {

const { t } = useI18n();

// stores
const userStore = useUserStore();
const schoolStore = useSchoolStore();
const subjectStore = useSubjectStore();
const schoolGroupStore = useSchoolGroupStore();
const adminStore = useAdminStore();
const filterStore = useFilterStore();
const dataStore = useDataStore();
const learnerStore = useLearnerStore();

// Define the Class type based on your classGroups structure
const selectedClass = ref<Class | null>(null)
// key to force remounting the FormKit form so validation resets on modal reopen
const editFormKey = ref(0)
const resetPasswordModalOpen = ref(false)
const resendInvitationModalOpen = ref(false);
const deleteTeacherModalOpen = ref(false)
const deleteTeacherSuccess = ref(false);
const showTeacherDeleteNotification = ref(false);
const confirmTeacherDeletionModal = ref(false);
const teacherToDelete = ref<Teacher | null>(null);
const selectedClassId = ref<string | null>("");
const deleteClassModalOpen = ref(false);
const classToDelete = ref<any>(null);
const editClassModalOpen = ref(false);
const cantDeleteModal = ref(false);
const formErrorAlert = ref<boolean>(false);
const formError = ref<string | null>(null);

// When the edit modal closes, clear validation/UI error state and remount the form
watch(editClassModalOpen, (isOpen) => {
    if (!isOpen) {
        formErrorAlert.value = false;
        formError.value = null;
        // bump the key so the FormKit form remounts and clears its internal validation state
        editFormKey.value += 1;
    }
});

// compare subject id with the user id to see if it is maths or english
const englishSubjectId = computed(() => subjectStore.getSubjects.find(s => s.name.toLowerCase() === 'english')?.id)
const mathsSubjectId = computed(() => subjectStore.getSubjects.find(s => s.name.toLowerCase() === 'maths')?.id)

// Helper functions to check subject type
function isEnglishClass(subjectId: string) {
    return subjectId === englishSubjectId.value
}

function isMathsClass(subjectId: string) {
    return subjectId === mathsSubjectId.value
}

const availableSubjects = computed(() => {
  return (schoolStore.getCurrentSchool?.subjectsAvailable || [])
    .map(subject => String(subject._id));
});

const hasMultipleSubjects = computed(() => availableSubjects.value.length > 1)

const hasEnglish = computed(() =>
  availableSubjects.value.some(subjectId => isEnglishClass(subjectId))
);

const hasMaths = computed(() =>
  availableSubjects.value.some(subjectId => isMathsClass(subjectId))
);

function openCantDeleteModal(classDetails: any) {
    selectedClass.value = classDetails
    classToDelete.value = classDetails;
    cantDeleteModal.value = true;
}
const originalTeacherId = ref<string | null>(null);

const isInternalAdmin = computed(() => userStore.isInternalAdmin);

const classesToDelete = ref<ClassToDelete[]>([] as ClassToDelete[]);

// Define a type for the teacher object
const designationOptions = [
    { label: "Class Teacher", value: "Class Teacher" },
    { label: "School Champion", value: "School Champion" },
    { label: "School Group Champion", value: "School Group Champion" },
];

// Load the assignedClasses for each teacher
onMounted(() => {
  const teachers = schoolStore.currentSchoolStructure?.allClassGroupAdmins || [];
  const uniqueTeachers = unionBy(teachers, "_id");
  uniqueTeachers.forEach((teacher: any) => {
    teacher.assignedClasses = getAssignedClasses(teacher._id);
  });
});

onBeforeMount(async () => {
    await schoolStore.getSchoolStructure;

    const currentSchoolId = schoolStore.getCurrentSchool?._id;
    const currentSchool = schoolStore.getCurrentSchool;
    const currentSchoolStructure = schoolStore.getSchoolStructure;
    const currentSubjects = subjectStore.getSubjects;
    const learners = learnerStore.getSchoolLearners;
});

const classes = computed(() => {
    const classGroups = schoolStore.currentSchoolStructure?.classGroups;
    if (!classGroups || !Array.isArray(classGroups)) {
        return null;
    }
    return classGroups;
});

// sorting variables
const visibleCount = ref(50)
const sortKey = ref('name')
const sortAsc = ref(true)

const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

const sortedUsers = computed(() => {
  return [...classes.value].sort((a, b) => {
    let valA;
    let valB;

    if (sortKey.value === 'name') {
      valA = a.name ?? '';
      valB = b.name ?? '';
    } else if (sortKey.value === 'subject') {
      valA = a.subject ?? '';
      valB = b.subject ?? '';
    } else if (sortKey.value === 'grade') {
      valA = Number(a.gradeLevel ?? 0);
      valB = Number(b.gradeLevel ?? 0);
    } else if (sortKey.value === 'studentCount') {
      valA = getLearnerCount(a._id);
      valB = getLearnerCount(b._id);
    } else if (sortKey.value === 'teacher') {
      valA = (a.admins?.[0]?.lastName ?? '');
      valB = (b.admins?.[0]?.lastName ?? '');
    }

    // Use natural string sort if both values are strings
    if (typeof valA === 'string' && typeof valB === 'string') {
      return sortAsc.value
        ? collator.compare(valA, valB)
        : collator.compare(valB, valA);
    }

    // Numeric fallback
    if (valA < valB) return sortAsc.value ? -1 : 1;
    if (valA > valB) return sortAsc.value ? 1 : -1;
    return 0;
  });
});

const paginatedUsers = computed(() => {
  return sortedUsers.value.slice(0, visibleCount.value);
});

const filteredClasses = computed(() => paginatedUsers.value);

const openLearnersByClass = (classGroupId: string) => {
    router.push({
        path: '/studentsnew',
        query: { classId: classGroupId }
    })
}

function sortBy(key: any) {
    if (!['name', 'subject', 'grade', 'teacher', 'studentCount'].includes(key)) return
    if (sortKey.value === key) {
        sortAsc.value = !sortAsc.value
    } else {
        sortKey.value = key
        sortAsc.value = true
    }
}

function loadMore() {
  visibleCount.value += 10;
}

const hasMore = computed(() => {
  return visibleCount.value < sortedUsers.value.length
});

// delete class modal
function openDeleteClassModal(teacher: any) {
    selectedClass.value = teacher
    classToDelete.value = teacher;
    deleteClassModalOpen.value = true
}

// delete teacher success
function notifySuccess() {
  showToast({
    text: t('internal_view.delete_teacher_success'),
    type: 'success',
    icon: CheckCircleIcon,
  })
}

// delete teacher error
function notifyError() {
  showToast({
    text: t('internal_view.delete_teacher_error'),
    type: 'error',
    icon: ExclamationCircleIcon,
  })
}

// delete teacher function
const removeTeacher = async (teacher: Teacher, e: Event) => {
  e.preventDefault();
  deleteTeacherSuccess.value = false;

  const teacherId = teacher._id;

  try {
    if (!teacherId) {
      throw new Error("Teacher ID is undefined");
    }

    const deletedTeacher = await adminStore.deleteClassGroupTeacher(teacherId, filterStore.selectedFilters.school);
    deleteTeacherSuccess.value = Boolean(deletedTeacher);
    showTeacherDeleteNotification.value = Boolean(deletedTeacher);

    if (deletedTeacher) {
      deleteTeacherModalOpen.value = false;
      notifySuccess();
    } else {
      notifyError();
    }
  } catch (error) {
    console.error("Failed to delete teacher:", error);
    deleteTeacherSuccess.value = false;
    notifyError();
  } finally {
    confirmTeacherDeletionModal.value = false;
  }
};

// Get assigned classes per teacher
const getAssignedClasses = (teacherId: any) => {
  const classes = schoolStore.currentSchoolStructure?.classGroups || [];
  const assignedClasses: {
    id: string;
    class: string;
    subject: string;
    learnerCount: number;
  }[] = [];

  classes.forEach((classItem) => {
    const admins = classItem.admins || [];
    admins.forEach((admin) => {

      if (admin && String(admin._id) === String(teacherId)) {
        const learnerCount = 0;
        assignedClasses.push({
          id: classItem._id,
          class: classItem.name,
          subject: classItem.subject,
          learnerCount,
        });
      }
    });
  });

  return assignedClasses;
};

// open edit teacher modal
const editTeacherModalOpen = ref(false);

// Save edited teacher
const loading = ref(false);

const buttonIsDisabled = computed(() => {
    return loading.value || !selectedClass.value || !selectedClass.value.name
});

const learners = learnerStore.getSchoolLearners;

// Method to get learner count based on class name and subject ID
const getLearnerCount = (classId: string) => {
  return (learners ?? []).filter((learner: any) => {
    return learner.classes?.some((classItem: any) => classItem._id === classId);
  }).length;
};

const removeClass = async (selectedClass: any, e: Event) => {
    e.preventDefault();
    
    const classObj = selectedClass;
    if (!classObj || !classObj._id) {
        showToast({
            text: "Error, please reload the school and try again.",
            type: 'error',
        });
        return;
    }

    loading.value = true;

    try {
        const response = await schoolStore.removeClassFromSchool(classObj._id);
        if (response.success) {
            showToast({
                text: response.message || "Class deleted successfully.",
                icon: CheckCircleIcon,
                type: 'success',
            });
        } else {
            showToast({
                text: response.message || "Could not delete class, please try again.",
                type: 'error',
            });
        }
    } catch (error) {
        console.error('Error deleting class:', error);
        showToast({
            text: "Error deleting class, please try again.",
            type: 'error',
        });
    } finally {
        deleteClassModalOpen.value = false;
        loading.value = false;
    }
};

function openEditClassModal(currentClass: Class) {
    selectedClass.value = { ...currentClass }; // bind to form
    //existing class teacher
    originalTeacherId.value =
    currentClass.admins && currentClass.admins[0] && currentClass.admins[0]._id
      ? currentClass.admins[0]._id
      : null;
    
    selectedClass.value.learningMode = selectedClass.value.learningMode || 'default';

    editClassModalOpen.value = true;
}

const teacherOptions = computed(() => {
  const seen = new Set();
  const options = (schoolStore.currentSchoolStructure?.allClassGroupAdmins ?? [])
  .filter(admin => admin && admin._id && !seen.has(admin._id) && seen.add(admin._id))
    .map(admin => {
      const fullName = `${admin.firstName} ${admin.lastName}`.trim().replace(/\s+/g, ' ');
      return {
        label: fullName,
        value: admin._id,
      };
    })
    .sort((a, b) => {
      const lastNameA = a.label.split(' ').slice(-1)[0].toLowerCase();
      const lastNameB = b.label.split(' ').slice(-1)[0].toLowerCase();
      return lastNameA.localeCompare(lastNameB);
    });

  // Add blank option at the top
  return [
    { label: "Assign Teacher", value: "" },
    ...options
  ];
});

// build your options array
const subjectOptions = computed(() => {
  const opts: { label: string; value: string }[] = []
  if (mathsSubjectId.value && schoolStore.getCurrentSchool?.subjectsAvailable.some(s => s._id === mathsSubjectId.value)) {
    opts.push({ label: 'Maths', value: mathsSubjectId.value })
  }
  if (englishSubjectId.value && schoolStore.getCurrentSchool?.subjectsAvailable.some(s => s._id === englishSubjectId.value)) {
    opts.push({ label: 'English', value: englishSubjectId.value })
  }
  return opts
})

// if exactly one option, we call it singleSubject
const singleSubject = computed(() =>
  subjectOptions.value.length === 1 ? subjectOptions.value[0] : null
)

// whenever singleSubject changes (or on mount), auto‑set the model
watch(singleSubject, (s) => {
  if (s && selectedClass.value) {
    selectedClass.value.subject = s.value
  }
}, { immediate: true })

const gradeOptions = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
];

const learningModes = computed(() => {
    const schoolDefault = schoolStore.currentSchoolStructure?.learningMode;
    const modes = schoolStore.getLearningModes || [];
    let defaultLabel = 'Default';

    if (schoolDefault && schoolDefault !== 'default') {
        const match = modes.find((m: any) => m.value === schoolDefault);
        if (match && match.label) {
            defaultLabel = `${String(match.label)} (default)`;
        } else {
            defaultLabel = `${String(schoolDefault)} (default)`;
        }
    }

    return [
        { label: defaultLabel, value: 'default' },
        ...modes.map(mode => ({ label: mode.label, value: mode.value }))
    ];
});

// Check if school is set to Lingo v2 only
const isV2Only = computed(() => schoolStore.lingoMode === 'v2');

onMounted(async () => {
  // console.log('preferred languages: ', schoolStore.locales);
});

const languageOptions = computed(() => {
    const preferredCode = schoolStore.currentSchoolStructure?.preferredLang || 'Default';
    return [
        { label: `${preferredCode} (default)`, value: 'default' },
        ...(schoolStore.locales || []).map((lang: any) => ({
            label: lang.code,
            value: lang.code
        }))
    ];
});

function classGroupNameExists(name: string, subject: unknown, currentClassId: string): boolean {
    const allClasses = schoolStore.currentSchoolStructure?.classGroups || [];

    const normalizeId = (value: unknown): string => {
        if (!value) return '';
        if (typeof value === 'string' || typeof value === 'number') return String(value);
        if (typeof value === 'object') {
            const valueRecord = value as Record<string, unknown>;
            return String(valueRecord._id ?? valueRecord.id ?? '');
        }
        return '';
    };

    const normalizeName = (value: string): string => (value ?? '').trim().toLowerCase();

    const normalizedCurrentClassId = normalizeId(currentClassId);
    const normalizedName = normalizeName(name);
    const normalizedSubjectId = normalizeId(subject);

    return allClasses.some((cls) => {
        const existingClassId = normalizeId(cls?._id);
        const existingName = normalizeName(cls?.name);
        const existingSubjectId = normalizeId(cls?.subject);

        return (
            existingClassId !== normalizedCurrentClassId &&
            existingName === normalizedName &&
            existingSubjectId === normalizedSubjectId
        );
    });
}

const saveEditedClass = async (selectedClass: any) => {
    loading.value = true;
    formErrorAlert.value = false;
    formError.value = null;

    try {
        const { _id, name, code, subject, gradeLevel, preferredLanguage, admins, learningMode } = selectedClass;
        const normalizedSubjectId =
            typeof subject === 'object' && subject !== null
                ? (subject._id ?? subject.id ?? '')
                : subject;

        // duplicate class name check AFTER validation passed
        if (classGroupNameExists(name, normalizedSubjectId, _id)) {
            formErrorAlert.value = true;
            formError.value = 'There is already another Class in the School with the same Name and Subject. You might be trying to create a duplicate Class.';
            loading.value = false;
            return;
        }

        const payload = {
            name,
            code,
            subject: normalizedSubjectId,
            gradeLevel,
            preferredLanguage,
            admin: admins[0]?._id || null,
            learningMode: learningMode || 'default'
        };

        // Only include previousAdmin if the teacher has changed
        if (
            originalTeacherId.value &&
            admins[0]?._id &&
            originalTeacherId.value !== admins[0]._id
        ) {
            payload.previousAdmin = originalTeacherId.value;
        }

        const response = await schoolStore.updateClass(_id, payload);

        if (response?._id) {
            showToast({
                text: t('admin_screens.alerts.success_saved'),
                type: 'success',
                icon: CheckCircleIcon,
            });
        } else {
            console.log(response);
            showToast({
                text: "There was an error updating the class.",
                type: 'error',
                icon: ExclamationCircleIcon,
            });    
        }
        editClassModalOpen.value = false;
    } catch (error) {
        showToast({
            text: "There was an error updating the class.",
            type: 'error',
            icon: ExclamationCircleIcon,
        });
    } finally {
        loading.value = false;
    }
}


return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (sortedUsers.value.length >= 1)
        ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_3, [
                _createElementVNode("th", {
                  class: "cursor-pointer text-xs text-tertiary font-medium py-4 px-8 text-left",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (sortBy('name')))
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createTextVNode(" Class "),
                    _createVNode(_component_rl_icon, {
                      icon: 'rl-sort-arrows',
                      title: 'rl question cirlce',
                      "aria-hidden": "true"
                    })
                  ])
                ]),
                (hasMultipleSubjects.value)
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 0,
                      class: "cursor-pointer text-xs text-tertiary font-medium py-4 px-8 text-left",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (sortBy('subject')))
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createTextVNode(" Subject "),
                        _createVNode(_component_rl_icon, {
                          icon: 'rl-sort-arrows',
                          title: 'rl question cirlce',
                          "aria-hidden": "true"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("th", {
                  class: "cursor-pointer text-xs text-tertiary font-medium py-4 pr-8 text-left flex py-4 px-8",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (sortBy('grade')))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createTextVNode(" Grade "),
                    _createVNode(_component_rl_icon, {
                      icon: 'rl-sort-arrows',
                      title: 'rl question cirlce',
                      "aria-hidden": "true"
                    })
                  ])
                ]),
                _createElementVNode("th", {
                  class: "cursor-pointer text-xs text-tertiary font-medium py-4 px-8 text-left",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (sortBy('studentCount')))
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(" Students "),
                    _createVNode(_component_rl_icon, {
                      icon: 'rl-sort-arrows',
                      title: 'rl question cirlce',
                      "aria-hidden": "true"
                    })
                  ])
                ]),
                _createElementVNode("th", {
                  class: "cursor-pointer text-xs text-tertiary font-medium py-4 px-8 text-left",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (sortBy('teacher')))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createTextVNode(" Teacher "),
                    _createVNode(_component_rl_icon, {
                      icon: 'rl-sort-arrows',
                      title: 'rl question cirlce',
                      "aria-hidden": "true"
                    })
                  ])
                ]),
                _hoisted_9
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredClasses.value, (user, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: user._id || index,
                  class: "border-t"
                }, [
                  _createElementVNode("td", _hoisted_10, _toDisplayString(user.name), 1),
                  (hasMultipleSubjects.value)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                        (user.subject && user.subject === englishSubjectId.value && hasEnglish.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, " English "))
                          : (user.subject && user.subject === mathsSubjectId.value && hasMaths.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Maths "))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(user.gradeLevel), 1),
                  _createElementVNode("td", _hoisted_15, [
                    (getLearnerCount(user._id) > 0)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: ($event: any) => (openLearnersByClass(user._id)),
                          class: "text-blue-600 hover:text-blue-500 font-medium"
                        }, _toDisplayString(getLearnerCount(user._id)), 9, _hoisted_16))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(getLearnerCount(user._id)), 1))
                  ]),
                  _createElementVNode("td", _hoisted_18, [
                    (user.admins[0])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(user.admins[0]?.firstName) + " " + _toDisplayString(user.admins[0]?.lastName), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_20, "None Assigned"))
                  ]),
                  _createElementVNode("td", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("a", {
                        href: "#",
                        class: "text-blue-600",
                        onClick: ($event: any) => (openEditClassModal(user))
                      }, "Edit", 8, _hoisted_23),
                      (getLearnerCount(user._id) === 0)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            class: "text-dark-red",
                            onClick: ($event: any) => (openDeleteClassModal(user))
                          }, " Delete ", 8, _hoisted_24))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: "#",
                            class: "text-dark-red",
                            onClick: ($event: any) => (openCantDeleteModal(user))
                          }, "Delete", 8, _hoisted_25))
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (sortedUsers.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-user',
                title: 'rl user',
                "aria-hidden": "true"
              }),
              _hoisted_28,
              _hoisted_29
            ])
          ]))
        : _createCommentVNode("", true),
      (sortedUsers.value.length >= 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("p", _hoisted_31, " Showing " + _toDisplayString(Math.min(visibleCount.value, sortedUsers.value.length)) + " of " + _toDisplayString(sortedUsers.value.length) + " Classes ", 1),
            (hasMore.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8 mx-2 flex flex-row justify-center items-center",
                  onClick: loadMore
                }, " Show 10 More "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-md',
      open: deleteClassModalOpen.value,
      onLocalModalOpen: _cache[7] || (_cache[7] = ($event: any) => (deleteClassModalOpen.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-delete',
              title: 'rl delete',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("h2", _hoisted_34, " Delete " + _toDisplayString(selectedClass.value?.name) + "? ", 1),
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (selectedClass.value && removeClass(selectedClass.value, $event))),
              class: "w-full font-semibold bg-red-600 rounded-lg py-2 px-6 text-white flex items-center justify-center gap-2"
            }, [
              _hoisted_37,
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (deleteClassModalOpen.value = false)),
              class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8 w-full"
            }, " Cancel ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-md',
      open: cantDeleteModal.value,
      onLocalModalOpen: _cache[9] || (_cache[9] = ($event: any) => (cantDeleteModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-delete',
              title: 'rl delete',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("h2", _hoisted_41, " There are " + _toDisplayString(getLearnerCount(selectedClass.value!._id)) + " Students in this Class ", 1),
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (cantDeleteModal.value = false)),
              class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8 w-full"
            }, " Cancel ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-3xl',
      open: editClassModalOpen.value,
      onLocalModalOpen: _cache[19] || (_cache[19] = ($event: any) => (editClassModalOpen.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-edit-teacher',
                title: 'rl edit teacher',
                class: "h-12 w-12 text-blue-600 mx-auto mb-4",
                "aria-hidden": "true"
              }),
              _hoisted_46
            ]),
            (formErrorAlert.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-alert-error',
                    title: 'rl alert error',
                    class: "h-8 w-8 text-red-500",
                    "aria-hidden": "true"
                  }),
                  _createElementVNode("span", null, _toDisplayString(formError.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              (_openBlock(), _createBlock(_component_FormKit, {
                key: editFormKey.value,
                type: "form",
                id: "edit-teacher-form",
                actions: false,
                config: { validationVisibility: 'submit' },
                onSubmit: _cache[18] || (_cache[18] = ($event: any) => (selectedClass.value && saveEditedClass(selectedClass.value)))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "Class Name",
                      placeholder: "Class Name",
                      "outer-class": "mb-4 w-full",
                      modelValue: selectedClass.value.name,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedClass.value.name) = $event)),
                      validation: "required|length:0,20",
                      "input-class": "w-full",
                      "validation-messages": {
                                    length: 'Class Name must be 20 characters or fewer.',
                                    required: 'Class Name is required.'
                                }
                    }, {
                      label: _withCtx(() => [
                        _hoisted_49,
                        _hoisted_50
                      ]),
                      suffix: _withCtx(({ node }) => [
                        (!node.context?.state.valid && node.context?.state.validationVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              _createVNode(_component_rl_icon, {
                                icon: "rl-alert-error",
                                title: "Error",
                                "aria-hidden": "true"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation-messages"]),
                    (!singleSubject.value)
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 0,
                          type: "select",
                          name: "Subject",
                          placeholder: "Subject",
                          "outer-class": "mb-4 w-full",
                          modelValue: selectedClass.value.subject,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selectedClass.value.subject) = $event)),
                          options: subjectOptions.value,
                          "input-class": "w-full"
                        }, {
                          label: _withCtx(() => [
                            _hoisted_52
                          ]),
                          suffix: _withCtx(({ node }) => [
                            (!node.context?.state.valid && node.context?.state.validationVisible)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                  _createVNode(_component_rl_icon, {
                                    icon: "rl-alert-error",
                                    title: "Error",
                                    "aria-hidden": "true"
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_FormKit, {
                      type: "select",
                      name: "Grade/Year",
                      label: "Grade/Year",
                      placeholder: "Select Grade/Year",
                      modelValue: selectedClass.value.gradeLevel,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedClass.value.gradeLevel) = $event)),
                      options: gradeOptions,
                      "outer-class": "mb-4 w-full",
                      "input-class": "w-full"
                    }, {
                      label: _withCtx(() => [
                        _hoisted_54
                      ]),
                      suffix: _withCtx(({ node }) => [
                        (!node.context?.state.valid && node.context?.state.validationVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                              _createVNode(_component_rl_icon, {
                                icon: "rl-alert-error",
                                title: "Error",
                                "aria-hidden": "true"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (!isV2Only.value)
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 1,
                          type: "select",
                          name: "Language",
                          label: "Language",
                          placeholder: "Language",
                          "outer-class": "mb-4 w-full",
                          modelValue: selectedClass.value.preferredLanguage,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((selectedClass.value.preferredLanguage) = $event)),
                          options: languageOptions.value,
                          "input-class": "w-full"
                        }, {
                          label: _withCtx(() => [
                            _hoisted_56,
                            _createElementVNode("span", _hoisted_57, [
                              _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_58, [
                                _createVNode(_component_rl_icon, {
                                  icon: 'rl-question-cirlce',
                                  title: 'rl question cirlce',
                                  "aria-hidden": "true"
                                })
                              ])), [
                                [
                                  _directive_tooltip,
                                  'This sets the Language of instruction for this Class, overriding the School Default if needed. This can be overridden by Student. Note that English language jurisdictions have distint spelling, notational conventions, units of measure, etc.',
                                  "bottom",
                                  { html: true }
                                ]
                              ])
                            ])
                          ]),
                          suffix: _withCtx(({ node }) => [
                            (!node.context?.state.valid && node.context?.state.validationVisible)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                  _createVNode(_component_rl_icon, {
                                    icon: "rl-alert-error",
                                    title: "Error",
                                    "aria-hidden": "true"
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"]))
                      : _createCommentVNode("", true),
                    (!isV2Only.value)
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 2,
                          type: "select",
                          placeholder: "Learning Mode",
                          "outer-class": "mb-4 w-full",
                          options: learningModes.value,
                          "input-class": "w-full",
                          modelValue: selectedClass.value.learningMode,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((selectedClass.value.learningMode) = $event))
                        }, {
                          label: _withCtx(() => [
                            _hoisted_60,
                            _createElementVNode("span", _hoisted_61, [
                              _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_62, [
                                _createVNode(_component_rl_icon, {
                                  icon: 'rl-question-cirlce',
                                  title: 'rl question cirlce',
                                  "aria-hidden": "true"
                                })
                              ])), [
                                [
                                  _directive_tooltip,
                                  'This sets the Learning Mode for this Student, overriding the Class/School default if needed. By default, students are Guided - through one journey at a time. Assess Ahead - allows assessment in all journeys from the start. Unguided - allows all journeys fully from the start.',
                                  "bottom",
                                  { html: true }
                                ]
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["options", "modelValue"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_63, [
                      (selectedClass.value.admins && selectedClass.value.admins[0] && selectedClass.value.admins[0]._id)
                        ? (_openBlock(), _createBlock(_component_FormKit, {
                            key: 0,
                            type: "select",
                            label: "Teacher",
                            placeholder: "Teacher",
                            modelValue: selectedClass.value.admins[0]._id,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedClass.value.admins[0]._id) = $event)),
                            options: teacherOptions.value,
                            "outer-class": "w-full"
                          }, null, 8, ["modelValue", "options"]))
                        : (_openBlock(), _createBlock(_component_FormKit, {
                            key: 1,
                            type: "select",
                            label: "Teacher",
                            placeholder: "Select Teacher",
                            options: teacherOptions.value,
                            "outer-class": "w-full",
                            value: '',
                            onInput: _cache[16] || (_cache[16] = id => {
                                    if (!selectedClass.value.admins) selectedClass.value.admins = [{}];
                                    if (!selectedClass.value.admins[0]) selectedClass.value.admins[0] = {};
                                    selectedClass.value.admins[0]._id = id;
                                })
                          }, null, 8, ["options"]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("button", _hoisted_65, [
                      (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
                          ]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" Save Changes ")
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (editClassModalOpen.value = false)),
                      class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full"
                    }, " Cancel ")
                  ])
                ]),
                _: 1
              })),
              _createVNode(_component_FormKit, {
                type: "hidden",
                name: "originalTeacherId",
                value: originalTeacherId.value
              }, null, 8, ["value"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})